StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.RadioButtonsHandler extends StepHandler

    inputSel: 'button.spp-radio-button'


    addValidationRules: () ->
        @validator.registerRule
            selector: '.validate-radio-button'
            text: '%s requires input'
            func: (elem) =>
                el = $(elem)
                aspectID = el.attr('data-aspect')

                group = @getInputEl(aspect: aspectID)

                return (!!group.filter('.active').length)


    getFieldAspect: (fieldID, aspectID) ->
        selectedOption = @getInputEl(aspect: aspectID).filter('.active')
        # selectedOption = @getInputEl(aspect: aspectID).filter(':checked')
        # selectedOption = $('input[type="radio"][data-aspect="'+aspectID+'"]:checked')

        optionValue = if selectedOption.attr('data-value') then parseInt selectedOption.attr('data-value') else null
        optionID = if selectedOption.attr('data-option')? then parseInt selectedOption.attr('data-option') else null
        optionName = @taffyObjects.options(id: optionID).select('display_name')[0]

        retval =
            value: optionValue
            options_id: optionID
            option_name: optionName

        return retval


    setFieldAspect: (fieldAspect) ->
        if fieldAspect.options_id
            input = @getInputEl
                aspect: fieldAspect.aspects_id
                option: fieldAspect.options_id
            input.addClass('active')
            # input.prop 'checked', true


    afterLoadLayout: (sel, data) ->
        super(sel, data)

        step = this

        # add radio-button-esque click handling
        @getInputEl().on 'click', () ->
            el = $(this)

            oldEl = step.getInputEl(
                aspect: el.attr('data-aspect')
            ).filter('.active')

            # check if the active cell changed
            if oldEl[0] isnt this
                oldEl.removeClass('active')
                el.addClass('active')

                oldEl.trigger('change')
                el.trigger('change')

            # prevent the default click handler
            return false
